<button
	class="filter-button mat-fab--p0"
	[class.active]="opened"
	[ngClass]="color"
	mat-fab
	aria-label="Filter icon-button"
	[ngStyle]="{ width: size, height: size }"
>
	<mat-icon
		[ngClass]="opened || color ? 'white-icon' : 'accent-icon'"
		svgIcon="{{ icon }}"
	></mat-icon>
</button>
